module.exports = __webpack_public_path__ + "Flag-703.714241e767890756a51a19e90036d06f.svg";